import React from "react";
import { DeliverysTemplates } from "../../Templates/DeliverysTemplate";

export const Deliverys = () => {
  return <DeliverysTemplates />;
};
